import { render, staticRenderFns } from "./tempFeePay.vue?vue&type=template&id=64470002"
import script from "./tempFeePay.vue?vue&type=script&lang=js"
export * from "./tempFeePay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports